export function ChangeMapLoading(loading){
    return{
        type: 'ChangeMapLoading',
        info: "ChangeMapLoading",
        payload: {loading: loading}
    }
}

export function ChangeMapShowCaption(showCaption){
    return{
        type: 'ChangeMapShowCaption',
        info: "ChangeMapShowCaption",
        payload: {showCaption: showCaption}
    }
}

export function ChangeMapEquipment(equipamento){
    return{
        type: 'ChangeMapEquipment',
        info: "ChangeMapEquipment",
        payload: {equipamento: equipamento}
    }
}

export function ChangeMapData(data){
    return{
        type: 'ChangeMapData',
        info: "ChangeMapData",
        payload: {data: data}
    }
}

export function ChangeMapState(state){
    return{
        type: 'ChangeMapState',
        info: "ChangeMapState",
        payload: {state: state}
    }
}

export function ChangeButtonsMap(Buttons){
    return{
        type: 'ChangeButtonsMap',
        info: "ChangeButtonsMap",
        payload: {Buttons: Buttons}
    }
}

export function ChangeEquipamentDataList(data){
    return{
        type: 'ChangeEquipamentDataList',
        info: "ChangeEquipamentDataList",
        payload: {data: data}
    }
}

export function ChangeCheckedTutorial(checkedTutorial){
    return{
        type: 'ChangeCheckedTutorial',
        info: "ChangeCheckedTutorial",
        payload: {checkedTutorial: checkedTutorial}
    }
}
